import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { Heading } from "@/components/Heading/Heading";
import { SmsMessage } from "@/components/SmsMessage/SmsMessage";
import { Tabs } from "@/components/Tabs/Tabs";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
import css from "./index.module.scss";

export const Route = createFileRoute("/_authenticated-user/sms-meldinger/")({
  loader: async () => {
    const result = await routeLoaderApiClient["sms-messages"].$get();

    if (result.ok === false) {
      throw new Error("Failed to fetch messages");
    }

    return {
      messages: await result.json(),
    };
  },
  head: () => ({
    meta: [{ title: "SMS-meldinger | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { messages } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>SMS-meldinger</DocumentTitle>

      <Tabs.Root defaultValue="sikring">
        <Tabs.List>
          <Tabs.Trigger value="sikring">Sikring</Tabs.Trigger>
          <Tabs.Trigger value="skjøte">Skjøte</Tabs.Trigger>
          <Tabs.Trigger value="hjemmelserklæring">Hjemmelserklæring</Tabs.Trigger>
          <Tabs.Trigger value="sletting">Sletting</Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="sikring">
          <MessageList messages={messages.sikring} />
        </Tabs.Content>

        <Tabs.Content value="skjøte">
          <MessageList messages={messages.skjøte} />
        </Tabs.Content>

        <Tabs.Content value="hjemmelserklæring">
          <MessageList messages={messages.hjemmelserklæring} />
        </Tabs.Content>

        <Tabs.Content value="sletting">
          <MessageList messages={messages.sletting} />
        </Tabs.Content>
      </Tabs.Root>
    </>
  );
}

function MessageList({ messages }: { messages: { initial: string; purringOne: string; purringTwoPlus: string } }) {
  return (
    <div className={css.messageList}>
      <div>
        <Heading className={css.messageHeading} level={3}>
          Første melding
        </Heading>
        <p className={css.description}>Sendes umiddelbart når dokumentet sendes til signering.</p>

        <SmsMessage text={messages.initial} />
      </div>

      <div>
        <Heading className={css.messageHeading} level={3}>
          Purring 1
        </Heading>
        <p className={css.description}>Sendes 48 timer etter den første meldingen.</p>

        <SmsMessage text={messages.purringOne} />
      </div>

      <div>
        <Heading className={css.messageHeading} level={3}>
          Purring 2
        </Heading>
        <p className={css.description}>Sendes 48 timer etter forrige purring (96 timer etter den første meldingen).</p>

        <SmsMessage text={messages.purringTwoPlus} />
      </div>

      <div>
        <Heading className={css.messageHeading} level={3}>
          Purring 3
        </Heading>
        <p className={css.description}>Sendes 72 timer etter forrige purring (1 uke etter den første meldingen).</p>

        <SmsMessage text={messages.purringTwoPlus} />
      </div>
    </div>
  );
}
